import { Grid, SkeletonPlaceholder } from '@modernhealth/vital-components';
import React from 'react';

export const SessionCardRowSkeleton: React.FC = () => {
  return (
    <Grid lgMode="3columns">
      <SessionCardSkeleton />
      <SessionCardSkeleton />
      <SessionCardSkeleton />
    </Grid>
  );
};

export const SessionCardSkeleton: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <SkeletonPlaceholder width={300} height={25} borderRadius={4} marginBottom={10} />
      <SkeletonPlaceholder width={150} height={25} borderRadius={4} marginBottom={10} />
      <SkeletonPlaceholder
        width={250}
        height={25}
        borderRadius={4}
        marginTop={40}
        marginBottom={25}
      />
      <SkeletonPlaceholder width={300} height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width={300} height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width={300} height={25} borderRadius={4} marginBottom={20} />
      <SkeletonPlaceholder width={200} height={40} borderRadius={4} />
    </div>
  );
};
